module.exports = __webpack_public_path__ + "media/newstyle/images/icon-lp-3-0be78391eaef80f9f721baa39bd3f12e.svg";